var $5779b104f19b7b1a$exports = {};
$5779b104f19b7b1a$exports = {
    "pending": `En attente`
};


export {$5779b104f19b7b1a$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
